export default {
    ca: {
        title: 'Duplicar el mapa',
        message: 'Segur que vols duplicar el mapa?',
        esborrar: 'Duplicar',
        messageError: 'No s\'ha pogut duplicar el mapa',
        duplicar: 'Copiar mapa',
        newMapNom: 'Nom del nou mapa',
        formValidation: 'El camp no pot estar buit',
        messageDuplicate: 'El procés de duplicar un mapa pot trigar minuts. Quan hagi acabat el procés trobareu el mapa duplicat a la vostra galeria.',
    },
    es: {
        title: 'Duplicar el mapa',
        message: '¿Seguro que quieres duplicar el mapa?',
        esborrar: 'Duplicar',
        messageError: 'No se ha podido duplicar el mapa',
        duplicar: 'Copiar mapa',
        newMapNom: 'Nombre del nuevo mapa',
        formValidation: 'El campo no puede estar vacío',
        messageDuplicate: 'El proceso de duplicar un mapa puede tardar unos minutos. Cuando haya acabado el proceso encontrareis el mapa duplicado en vuestra galeria.',
    },
    en: {
        title: 'Duplicate the map',
        message: 'Are you sure you want to duplicate the map?',
        esborrar: 'Duplicate',
        messageError: 'Could not duplicate the map',
        duplicar: 'Copy map',
        newMapNom: 'Name of the new map',
        formValidation: 'The field can\'t be left empty',
        messageDuplicate: 'The process of duplicating a map may take minutes. When the process is finished you will find the duplicated map in your gallery.',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/duplicar-modal/duplicar-modal-translations.js